import { apiFetch as fetch } from './apiConfig';
import {
  CompanionProfileStatus,
  CompanionEligibility,
  CompanionProfile,
} from '../types/companionProfile.types';

export interface ProfileStatusResponse {
  success: boolean;
  profile?: {
    id: string;
    userId: string;
    status: CompanionProfileStatus;
    pauseReason?: string | null;
    deletionRequestedAt?: string | null;
    updatedAt: string;
  };
  eligibility: CompanionEligibility;
  message?: string;
  code?: string;
}

export interface ProfileActionResponse {
  success: boolean;
  profileStatus?: CompanionProfileStatus;
  message: string;
  code?: string;
}

export async function getCompanionProfileStatus(
  userId?: string
): Promise<ProfileStatusResponse> {
  const url = userId
    ? `/api/companion/profile/status?userId=${encodeURIComponent(userId)}`
    : '/api/companion/profile/status';

  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-user-id': userId || localStorage.getItem('pairup_companion_user_id') || 'comp-01',
    },
  });

  return response.json();
}

export async function pauseProfile(
  pauseReason?: string,
  userId?: string
): Promise<ProfileActionResponse> {
  const response = await fetch('/api/companion/profile/pause', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-user-id': userId || localStorage.getItem('pairup_companion_user_id') || 'comp-01',
    },
    body: JSON.stringify({ pauseReason }),
  });

  return response.json();
}

export async function resumeProfile(
  userId?: string
): Promise<ProfileActionResponse> {
  const response = await fetch('/api/companion/profile/resume', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-user-id': userId || localStorage.getItem('pairup_companion_user_id') || 'comp-01',
    },
  });

  return response.json();
}

export async function requestDeleteAccount(
  userId?: string
): Promise<ProfileActionResponse> {
  const response = await fetch('/api/companion/account/delete-request', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-user-id': userId || localStorage.getItem('pairup_companion_user_id') || 'comp-01',
    },
  });

  return response.json();
}
